import { LIB_CONFIG } from '@/provide-lib-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
// import { LIB_CONFIG } from '@challenger/shared/lib-config';
// import { LibConfig } from '@challenger/shared/models/lib-config.model';
// import { HandshakeService } from '@challenger/shared/services/handshake.service';
import { v4 as uuidv4 } from 'uuid';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { Environment } from './../../../../environments/environment.interface';

export enum IdentifyCustomerByAddressResponse {
  NO_RESULT = 'NO_RESULT',
  ONE_RESULT = 'ONE_RESULT',
  MULTIPLE_RESULTS = 'MULTIPLE_RESULTS',
  VERIFIED_ACCOUNT = 'VERIFIED_ACCOUNT',
  UNVERIFIED_ACCOUNT = 'UNVERIFIED_ACCOUNT',
  ACCOUNT_CLOSED = 'ACCOUNT_CLOSED',
  UNIQUE_FOUND = 'UNIQUE_FOUND',
  POSTCODE_INVALID = 'POSTCODE_INVALID',
  TOO_SOON_TO_REGISTER = 'TOO_SOON_TO_REGISTER',
}

@Injectable({
  providedIn: 'root',
})
export class IdentifyCustomerByAddressService {
  private baseUrl = this.config?.apigeeApi?.baseUrl;
  constructor(
    private http: HttpClient,
    // private handshakeService: HandshakeService,
    @Inject(LIB_CONFIG) private config: Environment
  ) {}

  findByDetails(details: { postcode: string; lastName: string; house: string }, token: string) {
    const uuid = uuidv4();
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Bearer ' + token);
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('DAPI-AppID', this.config?.apigeeApi?.dapiAppId);
    headers = headers.set('DAPI-ClientSecret', this.config?.apigeeApi?.dapiClientSecret);
    headers = headers.set('DAPI-ChannelID', this.config?.apigeeApi?.dapiChannelId);
    headers = headers.set('DAPI-RequestID', uuid);
    headers = headers.set('DAPI-CorrelationID', uuid);
    headers = headers.set('DAPI-RequestTimestamp', new Date().toISOString());
    headers = headers.set('ZEUS-Location', window.location.pathname);

    const apiURL = `${this.baseUrl}${this.config.compaxAngularApi.findCustomer}`;
    const { house: streetNumber, ...rest } = details;
    const findDetails = { streetNumber, ...rest };
    return this.http.post(apiURL, findDetails, { headers }).pipe(
      mergeMap((results: any) => {
        return of(results);
      }),
      catchError((error) => {
        return of({ error });
      })
    );
  }
}
